import type { PaginatedMessagingAccount } from '@arhs-fleetback/types/entities/messaging-accounts';
import { createSelector } from 'reselect';

import type { MessagingAccountsReducer } from 'modules/messagingAccounts/reducers';
import type { RootState } from 'reducers/index';
import { getProps } from 'utils/selectors';

const getState = (state: RootState): MessagingAccountsReducer => state.messagingAccounts;

const getDataState = createSelector(getState, state => state.data);

const getEntities = createSelector(getDataState, data => data.entities);

export const getUIState = createSelector(getState, state => state.ui);

export const getMessagingAccountById = createSelector(getEntities, getProps<string>, (entities, accountId) => entities[accountId]);

export const getMessagingAccountsByIds = createSelector(getEntities, getProps<string[]>, (entities, accountIds) =>
  accountIds.reduce<PaginatedMessagingAccount[]>((acc, accountId) => {
    const account = entities[accountId];
    if (account) {
      acc.push(account);
    }
    return acc;
  }, []));
